import { compact } from 'lodash/fp';

import { CONTENT_SECTIONS } from '../../../content/sections';
import { ExternalContentOrProductListSectionOrPromotionalCtaListOrQuestionsListOrSellingPointGroupOrTopicGroupOrValuePropositionsObject as RefersToContent } from '../../../../../types/__codegen__/sanity/graphql';
import { WithOrderIndex } from '../types';
import mapExternalContent from '../map-external-content';
import mapQuestionsContent from '../map-questions-content';
import mapTilesContent from '../map-tiles-content';
import mapValuePropositionsContent from '../map-value-propositions-content';

type SectionWithIndex = WithOrderIndex<RefersToContent>;

const getFormattedSections = (sectionsWithIndex: SectionWithIndex[]) => {
  const formattedSections = sectionsWithIndex.map((section) => {
    const contentType = section?.__typename;

    if (contentType === CONTENT_SECTIONS.VALUE_PROPOSITIONS) {
      return mapValuePropositionsContent({ cmsSectionContent: section });
    }

    if (contentType === CONTENT_SECTIONS.PROMOTIONAL_TILES) {
      return mapTilesContent({ cmsSectionContent: section });
    }

    if (contentType === CONTENT_SECTIONS.COMMON_QUESTIONS) {
      return mapQuestionsContent({ cmsSectionContent: section });
    }

    if (contentType === CONTENT_SECTIONS.EXTERNAL_CONTENT) {
      return mapExternalContent({ cmsSectionContent: section });
    }

    if (contentType === CONTENT_SECTIONS.PRODUCT_LIST_SECTION) {
      return {
        defaultScale: section.defaultScale,
        name: section.title,
        orderIndex: section.orderIndex,
        productLists: section.productLists,
        type: CONTENT_SECTIONS.PRODUCT_LIST_SECTION,
      };
    }

    if (contentType === CONTENT_SECTIONS.TOPIC_GROUP) {
      return {
        ...section,
        topicGroup: compact(section.topicGroup),
        type: CONTENT_SECTIONS.TOPIC_GROUP,
      };
    }

    return null;
  });

  return formattedSections;
};

export default getFormattedSections;
